import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import {TABLE_TABS} from '../../../../constants';

const baselineDescription = formatMessage => {
	return {
		title: formatMessage({id: 'project_budget.baseline_definition_title'}),
		description: formatMessage({id: 'project_budget.baseline_definition_text'}),
	};
};
const fixedPriceDescription = formatMessage => {
	return {
		title: formatMessage({id: 'project_budget.fixed_price_definition'}),
		description: <FormattedHTMLMessage id={'project_budget.fixed_price_definition_description'} />,
	};
};
const varianceDescription = formatMessage => {
	return {
		title: formatMessage({id: 'project_budget.variance_definition'}),
		description: formatMessage({id: 'project_budget.variance_definition_description'}),
	};
};
export const offsetTooltip = formatMessage => {
	return [
		{
			title: formatMessage({id: 'project_budget.offset_definition'}),
			description: <FormattedHTMLMessage id={'project_budget.offset_definition_description'} />,
		},
	];
};

const ActualTooltips = (formatMessage, isMoneyTabSelected, showFixedPriceTooltip, selectedTabTemp) => {
	if (isMoneyTabSelected) {
		switch (selectedTabTemp) {
			case TABLE_TABS.WORK:
				return {
					revenue: [
						showFixedPriceTooltip ? fixedPriceDescription(formatMessage) : {hide: true},
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: showFixedPriceTooltip
								? [formatMessage({id: 'project_budget.done_task_value'}), '/', formatMessage({id: 'project_budget.total_task_value'}), 'x', formatMessage({id: 'common.fixed_price'})]
								: [formatMessage({id: 'project_budget.all_billable_time_entries'}), 'x', formatMessage({id: 'project_budget.role_rate'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.all_time_registrations'}), 'x', formatMessage({id: 'project_budget.internal_cost'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.actual_revenue'}), '-', formatMessage({id: 'insights.component.list.column.actualCost'})],
						},
					],
					offset: offsetTooltip(formatMessage),
				};
			case TABLE_TABS.EXPENSES:
				return {
					revenue: [
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: [formatMessage({id: 'project_budget.price_past_planned_expenses'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.cost_past_expenses'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.actual_revenue'}), '-', formatMessage({id: 'insights.component.list.column.actualCost'})],
						},
					],
				};
			default:
				return {
					revenue: [
						showFixedPriceTooltip ? fixedPriceDescription(formatMessage) : {hide: true},
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: showFixedPriceTooltip
								? [
										formatMessage({id: 'project_budget.done_task_value'}),
										'/',
										formatMessage({id: 'project_budget.total_task_value'}),
										'x',
										formatMessage({id: 'common.fixed_price'}),
										'+',
										formatMessage({id: 'project_budget.price_past_planned_expenses'}),
								  ]
								: [formatMessage({id: 'project_budget.all_billable_time_entries'}), 'x', formatMessage({id: 'project_budget.role_rate'}), '+', formatMessage({id: 'project_budget.price_past_planned_expenses'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.all_time_registrations'}), 'x', formatMessage({id: 'project_budget.internal_cost'}), '+', formatMessage({id: 'project_budget.cost_past_expenses'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.actual_revenue'}), '-', formatMessage({id: 'insights.component.list.column.actualCost'})],
						},
					],
					margin: [
						{
							title: formatMessage({id: 'common.margin'}),
							details: [formatMessage({id: 'project_budget.actual_profit'}), '/', formatMessage({id: 'project_budget.actual_revenue'}), 'x', '100'],
						},
					],
					offset: offsetTooltip(formatMessage),
				};
		}
	} else {
		return {
			constantTooltip: [{details: [formatMessage({id: 'project_budget.all_time_entries'})]}],
		};
	}
};

const PlanTooltips = (formatMessage, isMoneyTabSelected, showFixedPriceTooltip, selectedTabTemp) => {
	if (isMoneyTabSelected) {
		switch (selectedTabTemp) {
			case TABLE_TABS.WORK:
				return {
					revenue: [
						showFixedPriceTooltip ? fixedPriceDescription(formatMessage) : {hide: true},
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: showFixedPriceTooltip ? [formatMessage({id: 'common.fixed_price'})] : [formatMessage({id: 'project_budget.all_billable_forecast_hours'}), 'x', formatMessage({id: 'project_budget.role_rate'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.all_forecast_hours'}), 'x', formatMessage({id: 'project_budget.internal_cost'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.plan_revenue'}), '-', formatMessage({id: 'project_budget.plan_cost'})],
						},
					],
				};
			case TABLE_TABS.EXPENSES:
				return {
					revenue: [
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: [formatMessage({id: 'project_budget.price_all_planned_expenses'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.cost_all_planned_expenses'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.plan_revenue'}), '-', formatMessage({id: 'project_budget.plan_cost'})],
						},
					],
				};
			default:
				return {
					revenue: [
						fixedPriceDescription(formatMessage),
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: showFixedPriceTooltip
								? [formatMessage({id: 'common.fixed_price'}), '+', formatMessage({id: 'project_budget.price_all_planned_expenses'})]
								: [formatMessage({id: 'project_budget.all_billable_forecast_hours'}), 'x', formatMessage({id: 'project_budget.role_rate'}), '+', formatMessage({id: 'project_budget.price_all_planned_expenses'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: showFixedPriceTooltip
								? [formatMessage({id: 'project_budget.task_estimate'}), 'x', formatMessage({id: 'project_budget.internal_cost'}), '+', formatMessage({id: 'project_budget.cost_all_planned_expenses'})]
								: [formatMessage({id: 'project_budget.task_estimate'}), 'x', formatMessage({id: 'project_budget.internal_cost'}), '+', formatMessage({id: 'project_budget.cost_all_planned_expenses'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.plan_revenue'}), '-', formatMessage({id: 'project_budget.plan_cost'})],
						},
					],
					margin: [
						{
							title: formatMessage({id: 'common.margin'}),
							details: [formatMessage({id: 'project_budget.planned_profit'}), '/', formatMessage({id: 'project_budget.planned_revenue'}), 'x', '100'],
						},
					],
				};
		}
	} else {
		return {
			constantTooltip: [{details: [formatMessage({id: 'project_budget.all_forecast_hours'})]}],
		};
	}
};

const RemainingTooltips = (formatMessage, isMoneyTabSelected, showFixedPriceTooltip, selectedTabTemp) => {
	if (isMoneyTabSelected) {
		switch (selectedTabTemp) {
			case TABLE_TABS.WORK:
				return {
					revenue: [
						showFixedPriceTooltip ? fixedPriceDescription(formatMessage) : {hide: true},
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: showFixedPriceTooltip
								? [formatMessage({id: 'project_budget.not_done_task_value'}), '/', formatMessage({id: 'project_budget.total_task_value'}), 'x', formatMessage({id: 'common.fixed_price'})]
								: [formatMessage({id: 'project_budget.all_remaining_billable_hours'}), 'x', formatMessage({id: 'project_budget.role_rate'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.all_remaining_hours'}), 'x', formatMessage({id: 'project_budget.internal_cost'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.remaining_revenue'}), '-', formatMessage({id: 'project_budget.remaining_cost'})],
						},
					],
				};
			case TABLE_TABS.EXPENSES:
				return {
					revenue: [
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: [formatMessage({id: 'project_budget.price_future_planned_expenses'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.cost_future_planned_expenses'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.remaining_revenue'}), '-', formatMessage({id: 'project_budget.remaining_cost'})],
						},
					],
				};
			default:
				return {
					revenue: [
						showFixedPriceTooltip ? fixedPriceDescription(formatMessage) : {hide: true},
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: showFixedPriceTooltip
								? [
										formatMessage({id: 'project_budget.not_done_task_value'}),
										'/',
										formatMessage({id: 'project_budget.total_task_value'}),
										'x',
										formatMessage({id: 'common.fixed_price'}),
										'+',
										formatMessage({id: 'project_budget.price_future_planned_expenses'}),
								  ]
								: [formatMessage({id: 'project_budget.all_remaining_billable_hours'}), 'x', formatMessage({id: 'project_budget.role_rate'}), '+', formatMessage({id: 'project_budget.price_future_expenses'})],
						},
					],
					cost: [
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.remaining_task_estimate'}), 'x', formatMessage({id: 'project_budget.internal_cost'}), '+', formatMessage({id: 'project_budget.cost_future_planned_expenses'})],
						},
					],
					profit: [
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.remaining_revenue'}), '-', formatMessage({id: 'project_budget.remaining_cost'})],
						},
					],
					margin: [
						{
							title: formatMessage({id: 'common.margin'}),
							details: [formatMessage({id: 'project_budget.remaining_profit'}), '/', formatMessage({id: 'project_budget.remaining_revenue'}), 'x', '100'],
						},
					],
				};
		}
	} else {
		return {
			constantTooltip: [{details: [formatMessage({id: 'project_budget.all_remaining_hours'})]}],
		};
	}
};

const ForecastTooltips = (formatMessage, isMoneyTabSelected) => {
	if (isMoneyTabSelected) {
		return {
			revenue: [
				{
					title: formatMessage({id: 'project_budget.revenue'}),
					details: [formatMessage({id: 'project_budget.actual_revenue'}), '+', formatMessage({id: 'project_budget.remaining_revenue'})],
				},
			],
			cost: [
				{
					title: formatMessage({id: 'common.cost'}),
					details: [formatMessage({id: 'insights.component.list.column.actualCost'}), '+', formatMessage({id: 'project_budget.remaining_cost'})],
				},
			],
			profit: [
				{
					title: formatMessage({id: 'common.profit'}),
					details: [formatMessage({id: 'project_budget.forecast_revenue'}), '-', formatMessage({id: 'project_budget.forecast_cost'})],
				},
			],
			margin: [
				{
					title: formatMessage({id: 'common.margin'}),
					details: [formatMessage({id: 'project_budget.forecast_profit'}), '/', formatMessage({id: 'project_budget.forecast_revenue'}), 'x', '100'],
				},
			],
		};
	} else {
		return {
			constantTooltip: [
				{
					details: [formatMessage({id: 'project_budget.actuals'}), '+', formatMessage({id: 'common.remaining'})],
				},
			],
		};
	}
};

const ActualVsPlanTooltips = (formatMessage, isMoneyTabSelected) => {
	if (isMoneyTabSelected) {
		return {
			revenue: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'project_budget.revenue'}),
					details: [formatMessage({id: 'project_budget.actual_revenue'}), '-', formatMessage({id: 'project_budget.planned_revenue'})],
				},
			],
			cost: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.cost'}),
					details: [formatMessage({id: 'insights.component.list.column.actualCost'}), '-', formatMessage({id: 'project_budget.planned_cost'})],
				},
			],
			profit: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.profit'}),
					details: [formatMessage({id: 'project_budget.variance_revenue'}), '-', formatMessage({id: 'project_budget.variance_cost'})],
				},
			],
		};
	} else {
		return {
			constantTooltip: [varianceDescription(formatMessage), {details: [formatMessage({id: 'project_budget.actuals'}), '-', formatMessage({id: 'common.plan'})]}],
		};
	}
};

const ForecastVsPlanTooltips = (formatMessage, isMoneyTabSelected) => {
	if (isMoneyTabSelected) {
		return {
			revenue: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'project_budget.revenue'}),
					details: [formatMessage({id: 'project_budget.forecast_revenue'}), '-', formatMessage({id: 'project_budget.planned_revenue'})],
				},
			],
			cost: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.cost'}),
					details: [formatMessage({id: 'project_budget.forecast_cost'}), '-', formatMessage({id: 'project_budget.planned_cost'})],
				},
			],
			profit: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.profit'}),
					details: [formatMessage({id: 'project_budget.variance_revenue'}), '-', formatMessage({id: 'project_budget.variance_cost'})],
				},
			],
		};
	} else {
		return {
			constantTooltip: [
				varianceDescription(formatMessage),
				{
					details: [formatMessage({id: 'project_budget.actuals'}), '+', formatMessage({id: 'common.remaining'}), '-', formatMessage({id: 'common.plan'})],
				},
			],
		};
	}
};

const FixedPriceTooltips = formatMessage => {
	return {
		revenue: [
			{
				title: formatMessage({id: 'project_budget.revenue'}),
				details: [formatMessage({id: 'common.fixed_price'})],
			},
		],
		cost: [
			{
				title: formatMessage({id: 'common.cost'}),
				details: [formatMessage({id: 'insights.component.list.column.costForecast'})],
			},
		],
		profit: [
			{
				title: formatMessage({id: 'common.profit'}),
				details: [formatMessage({id: 'common.fixed_price'}), '-', formatMessage({id: 'insights.component.list.column.costForecast'})],
			},
		],
	};
};

const FixedPriceProjectFinancialsTooltip = formatMessage => {
	return [
		{
			title: formatMessage({id: 'project_budget.revenue'}),
			details: [formatMessage({id: 'common.fixed_price'})],
		},
		{
			title: formatMessage({id: 'common.cost'}),
			details: [formatMessage({id: 'insights.component.list.column.costForecast'})],
		},
		{
			title: formatMessage({id: 'common.profit'}),
			details: [formatMessage({id: 'common.fixed_price'}), '-', formatMessage({id: 'insights.component.list.column.costForecast'})],
		},
		{
			title: formatMessage({id: 'project_budget.fixed_price_spent'}),
			details: [formatMessage({id: 'project_budget.actual_revenue'})],
		},
		{
			title: formatMessage({id: 'project_budget.fixed_price_remaining'}),
			details: [formatMessage({id: 'common.fixed_price'}), '-', formatMessage({id: 'project_budget.actual_revenue'})],
		},
	];
};

const BaselineTooltips = (formatMessage, isMoneyTabSelected, selectedTabTemp) => {
	if (isMoneyTabSelected) {
		switch (selectedTabTemp) {
			case TABLE_TABS.WORK:
				return {
					revenue: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: [formatMessage({id: 'common.total_estimate'}), 'x', formatMessage({id: 'project_budget.role_rate'})],
						},
					],
					cost: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'common.total_estimate'}), 'x', formatMessage({id: 'project_budget.adjusted_cost_rate'})],
						},
					],
					profit: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.baseline_revenue'}), '-', formatMessage({id: 'project_budget.baseline_cost'})],
						},
					],
				};
			case TABLE_TABS.EXPENSES:
				return {
					revenue: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: [formatMessage({id: 'project_budget.expense_revenue'})],
						},
					],
					cost: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'project_budget.expense_cost'})],
						},
					],
					profit: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.baseline_revenue'}), '-', formatMessage({id: 'project_budget.baseline_cost'})],
						},
					],
				};
			default:
				return {
					revenue: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'project_budget.revenue'}),
							details: [formatMessage({id: 'common.total_estimate'}), 'x', formatMessage({id: 'project_budget.role_rate'}), '+', formatMessage({id: 'project_budget.expense_revenue'})],
						},
					],
					cost: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'common.cost'}),
							details: [formatMessage({id: 'common.total_estimate'}), 'x', formatMessage({id: 'project_budget.adjusted_cost_rate'}), '+', formatMessage({id: 'project_budget.expense_cost'})],
						},
					],
					profit: [
						baselineDescription(formatMessage),
						{
							title: formatMessage({id: 'common.profit'}),
							details: [formatMessage({id: 'project_budget.baseline_revenue'}), '-', formatMessage({id: 'project_budget.baseline_cost'})],
						},
					],
					margin: [
						{
							title: formatMessage({id: 'common.margin'}),
							details: [formatMessage({id: 'project_budget.baseline_profit'}), '/', formatMessage({id: 'project_budget.baseline_revenue'}), 'x', '100'],
						},
					],
				};
		}
	} else {
		return {
			constantTooltip: [
				baselineDescription(formatMessage),
				{
					details: [formatMessage({id: 'common.total_estimate'})],
				},
			],
		};
	}
};

const BaselineVsForecastTooltips = (formatMessage, isMoneyTabSelected) => {
	if (isMoneyTabSelected) {
		return {
			revenue: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'project_budget.revenue'}),
					details: [formatMessage({id: 'project_budget.baseline_revenue'}), '-', formatMessage({id: 'project_budget.forecast_revenue'})],
				},
			],
			cost: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.cost'}),
					details: [formatMessage({id: 'project_budget.baseline_cost'}), '-', formatMessage({id: 'project_budget.forecast_cost'})],
				},
			],
			profit: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.profit'}),
					details: [formatMessage({id: 'project_budget.variance_revenue'}), '-', formatMessage({id: 'project_budget.variance_cost'})],
				},
			],
		};
	} else {
		return {
			constantTooltip: [
				varianceDescription(formatMessage),
				{
					details: [formatMessage({id: 'common.total_estimate'}), '-', formatMessage({id: 'project_budget.actuals'}), '+', formatMessage({id: 'common.remaining'})],
				},
			],
		};
	}
};

const BaselineVsActualsTooltips = (formatMessage, isMoneyTabSelected) => {
	if (isMoneyTabSelected) {
		return {
			revenue: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'project_budget.revenue'}),
					details: [formatMessage({id: 'project_budget.baseline_revenue'}), '-', formatMessage({id: 'project_budget.actual_revenue'})],
				},
			],
			cost: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.cost'}),
					details: [formatMessage({id: 'project_budget.baseline_cost'}), '-', formatMessage({id: 'insights.component.list.column.actualCost'})],
				},
			],
			profit: [
				varianceDescription(formatMessage),
				{
					title: formatMessage({id: 'common.profit'}),
					details: [formatMessage({id: 'project_budget.variance_revenue'}), '-', formatMessage({id: 'project_budget.variance_cost'})],
				},
			],
		};
	} else {
		return {
			constantTooltip: [
				varianceDescription(formatMessage),
				{
					details: [formatMessage({id: 'common.total_estimate'}), '-', formatMessage({id: 'project_budget.actuals'})],
				},
			],
		};
	}
};

const InvoicedVsActualsTooltips = (formatMessage, isMoneyTabSelected) => {
	if (isMoneyTabSelected) {
		return {'accrued/deferred': [varianceDescription(formatMessage), {title: formatMessage({id: 'common.variance'}), details: [formatMessage({id: 'project_section.invoice'}), '-', formatMessage({id: 'project_budget.actual_revenue'})]}]};
	}
};

export const BudgetTooltips = {
	ActualTooltips,
	PlanTooltips,
	RemainingTooltips,
	ForecastTooltips,
	ActualVsPlanTooltips,
	ForecastVsPlanTooltips,
	FixedPriceTooltips,
	FixedPriceProjectFinancialsTooltip,
	BaselineTooltips,
	BaselineVsActualsTooltips,
	BaselineVsForecastTooltips,
	InvoicedVsActualsTooltips,
};
